// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"1f99da8a","154":"bbf475f5","170":"2b58729c","399":"53421046","436":"bb8fd67c","562":"d220c98c","646":"bc828a11","751":"eea1585a","933":"2f6bb64e","953":"6b65b423"}[chunkId] + ".chunk.js";
};